// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './routers'
import rem from './rem'
// 轮播图
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)


// aos动画插件
import AOS from 'aos'

import 'aos/dist/aos.css'
AOS.init();

//引入axios解决网络请求
import axios from 'axios'
//添加到原型上，保证任何地方
//可以使用
Vue.prototype.axios = axios;

Vue.config.productionTip = false


// 判断一个元素是否进入了可视化范围之内
import VisibilityObserver from './visibility-observer'

Vue.use(VisibilityObserver, {
  // 可选全局默认配置
  threshold: 0.1
})

// 封装一个滚动条插件

const throttle = (fn) => {
  let isRunning = false
  return (...args) => {
    if (!isRunning) {
      isRunning = true
      window.requestAnimationFrame(() => {
        fn.apply(this, args)
        isRunning = false
      })
    }
  }
}
// scroll-manager.js
const scrollManager = {
  // 使用普通 Map 存储 window 监听器
  windowListeners: new Set(),
  // 使用 WeakMap 存储普通元素的监听器
  elementListeners: new WeakMap(),

  addListener(el, callback) {
    const target = this.normalizeTarget(el)
    if (!target) return () => {}
    // 分离处理 window 和普通元素
    if (target === window) {
      var callbackFn = this.handleWindow(target, callback)
      return callbackFn
    } else {
      return this.handleElement(target, callback)
    }
  },

  // 处理 window 监听
  handleWindow(target, callback) {
    console.log(this.windowListeners,'小数')
    
    const scrollData = {
      top: window.pageYOffset,
      left: window.pageXOffset,
      element: window
    }
    this.windowListeners = new Set()
    this.windowListeners.forEach((dcs)=>{
      
      window.addEventListener('scroll', dcs, { passive: true })

    })

    // 初始化 window 监听
    if (this.windowListeners.size === 0) {
      const handler = throttle(() => {
        const scrollData = {
          top: window.pageYOffset,
          left: window.pageXOffset,
          element: window
        }
        this.windowListeners.forEach(cb => cb(scrollData))
      })
      window.addEventListener('scroll', handler, { passive: true })
      this.windowHandler = handler
    }

    this.windowListeners.add(callback)
    
    // 返回清理函数
    return () => {
      this.windowListeners.delete(callback)
      if (this.windowListeners.size === 0) {
        
        window.removeEventListener('scroll', this.windowHandler)
        this.windowHandler = null
      }
    }
  },

  // 处理普通元素监听（保留原有优化）
  handleElement(target, callback) {
    let listeners = this.elementListeners.get(target)
    
    if (!listeners) {
      const handler = throttle(() => {
        const scrollData = {
          top: target.scrollTop,
          left: target.scrollLeft,
          element: target
        }
        listeners.callbacks.forEach(cb => cb(scrollData))
      })
      
      listeners = {
        handler,
        callbacks: new Set()
      }
      target.addEventListener('scroll', handler, { passive: true })
      this.elementListeners.set(target, listeners)
    }

    listeners.callbacks.add(callback)

    return () => {
      listeners.callbacks.delete(callback)
      if (listeners.callbacks.size === 0) {
        target.removeEventListener('scroll', handler)
        this.elementListeners.delete(target)
      }
    }
  },

  normalizeTarget(el) {
    // 统一目标处理逻辑
    if (el === window) return window
    if (el instanceof Element) return el
    if (typeof el === 'string') {
      return document.querySelector(el) || console.error(`元素不存在: ${el}`)
    }
    return null
  }
}

// vue-plugin.js
const ScrollListener = {
  install(app) {
    const isVue3 = 'config' in app
    // const prototype = isVue3 ? app.config.globalProperties : app.prototype

    Vue.prototype.$listenScroll = function(callback, el = window) {
      let unsubscribe = () => {}
      let isActive = true

      const bind = () => {
        if (!isActive) return
        unsubscribe = scrollManager.addListener(el, callback)
      }

      const unbind = () => {
        isActive = false
        
        unsubscribe()
      }

      // 绑定生命周期（增强版）
      const hooks = {
        mounted: bind,
        activated: bind,
        beforeUnmount: unbind,
        deactivated: unbind,
        errorCaptured: unbind
      }

      if (!isVue3) {
        Object.entries(hooks).forEach(([hook, handler]) => {
          app.mixin({
            [hook]() {
              if (this === this.$root) {
                return handler.call(this)
              }
              
            }
          })
        })
      } else {
        app.mixin({
          mounted() { bind.call(this) },
          activated() { bind.call(this) },
          beforeDestroy() { unbind.call(this) },
          deactivated() { unbind.call(this) },
          errorCaptured() { unbind.call(this) }
        })
      }

      // 立即绑定
      bind()

      return unbind
    }
  }
}

Vue.use(ScrollListener.install)



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js